import { sendGTMEvent } from "@next/third-parties/google";

/**
 * The one reusable primitive for talking to GTM: push an arbitrary object onto
 * the dataLayer. Every tracked event goes through here.
 *
 * `sendGTMEvent` (from `@next/third-parties/google`) defines `window.dataLayer`
 * first, so events fired before the GTM script finishes loading are queued
 * rather than dropped. Guarded against SSR so callers don't have to.
 */
export const sendEvent = (data: Record<string, unknown>) => {
	if (typeof window === "undefined") return;
	sendGTMEvent(data);
};
